import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { SAFETY_CHECKLIST_API } from "../apiRoutes";

interface mutateProps {
  checklistId: string;
  id: string
}

const mutateDeleteSafetyChecklistItem = async ({
  checklistId,
  id,
}: mutateProps) => {
  return await axiosAuth.delete(
    `${SAFETY_CHECKLIST_API}/${checklistId}/items/${id}`,
  );
};

const useDeleteSafetyChecklistItemMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteSafetyChecklistItem,
    ...queryParams,
  });

export default useDeleteSafetyChecklistItemMutation;
